export const blockuiConstants = {
  BLOCKUI_LOADING: 'BLOCKUI_LOADING',
  BLOCKUI_DONE: 'BLOCKUI_DONE',
}
